class ConvertSettingsStorage {
  private readonly removeInstrumentalsKey = "removeInst";
  private readonly removeReverbKey = "removeRever";

  public saveRemoveInstrumentals(removeInstrumentals: boolean): void {
    localStorage.setItem(
      this.removeInstrumentalsKey,
      String(removeInstrumentals),
    );
  }

  public getRemoveInstrumentals(): boolean {
    return this.tryGetBooleanSettingByKey(this.removeInstrumentalsKey);
  }

  public saveRemoveReverb(removeReverb: boolean): void {
    localStorage.setItem(this.removeReverbKey, String(removeReverb));
  }

  public getRemoveReverb(): boolean {
    return this.tryGetBooleanSettingByKey(this.removeReverbKey);
  }

  private tryGetBooleanSettingByKey(key: string): boolean {
    if (typeof window !== "undefined") {
      return localStorage.getItem(key) === "true";
    }
    return false;
  }
}

const convertSetting = new ConvertSettingsStorage();
export { convertSetting };
